<template>
  <div class="form-button-group">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
/* ... */
</script>

<style lang="scss" scoped>
.form-button-group {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5em;
}
</style>
